/**
 * Created by mykurisu on 2017/6/23.
 */
import React from 'react'
import {connect} from 'react-redux'
import { bindActionCreators } from 'redux'
import qs from 'qs'
import qrcode from 'qrcode'
import {browserHistory}  from 'react-router'
import {
    Page,
    Preload,
    FollowLiveroom,
    WKError,
    WKToShareCard,
    ReceiveCoupon,
} from '../components'
import {AideCard} from '../components/common'
import {
    LiveroomChannelListArea,
    LiveroomClassListArea,
    LiveroomLectureBtn,
    LiveroomQrcode,
    LiveroomSlideTopBar,
    LiveroomNoneItem,
    LiveroomSchduleListArea,
    LiveroomRealData,
    LiveroomWeekBar,
    LiveroomBottomStudentNav,
} from '../components/liveroom'
import {WKOperation, WKVisible} from '../components/wk'
import LiveroomRebateModal from '../pages/liveroomCreate/LiveroomRebateModal'
import {Dialog} from 'react-weui'
import {getJsonFromUrl, getToken, storage} from '../utils'
import Config from '../config'
import {renderMoney,AddRef} from '../utils'
import Pay from '../components/Pay'
import axios from 'axios'
import {CouponBar} from '../components/details'
import * as liveroomAction from '../actions/liveroom'

import '../styles/liveroom.css'
import '../styles/component.css'
import '../css/page/LiveroomPage.css'
import '../styles/liveroom/LiveroomTopBar.css'

import errorImg from '../images/no-source.png';
import VIPIcon from '../images/liveroom/VIPIcon.png'
import LectureEditIcon from '../images/liveroom/lecture_edit.png'
import ChannelEditIcon from '../images/liveroom/channel_edit.png'
import refundManage from '../images/liveroom/refund-manage@3x.png'
import discountCoupon from '../images/liveroom/discount-coupon@3x.png'
import vipMember from '../images/liveroom/vip-member@3x.png'
import setting from '../images/liveroom/setting@3x.png'
import discussManage from '../images/liveroom/comment@3x.png'

class LiveroomPage extends React.Component {

    constructor() {
        super();
        this.state = {
            scene: 'liveroom',
            action: 'look',
            refundCount: 0,
            discussCount: 0,
            alertShow: false,
            isShowRebateModal: false,
            qrImg: '',
            isRealDataLoading: true,
            openOtherActionSheet:false,
            isInitIdentit: false,
            isManager:false,
        }
    }

    componentDidMount() {
        // 初始化直播间数据
        let {liveroom_id} = this.props.params;
        // 判断有没有fr
        const fr = storage.getItem('liveroom_create_fr')
        storage.removeItem('liveroom_create_fr')
        storage.removeItem('liveroom_create_is_follow')

        if (this.props.location.query.st === 'invite_rebate') {
            return browserHistory.replace('/specials/activity/liveroom_create_rebate')
        }

        //检测该页面是否有优惠券
        axios.get(`/api/coupon/liveroom/${liveroom_id}/check_has_coupons`)
            .then(res => {
                if (res.data.code === 0){
                    if (res.data.data.has_active_coupons){
                        this.props.dispatch({
                            type: 'NEW_COUPON_CHECKED'
                        })
                    }
                }
            });


        let liveroomInfoParams = {}
        if (fr) {
            liveroomInfoParams = { ...liveroomInfoParams, fr: fr }
        }
        if (this.props.location.query.st) {
            liveroomInfoParams = { ...liveroomInfoParams, st: this.props.location.query.st }
        }
        if (this.props.location.query.inviter_id) {
            liveroomInfoParams = { ...liveroomInfoParams, inviter_id: this.props.location.query.inviter_id }
        }
        axios.get(`/api/liveroom/${liveroom_id}/info`, {
            params: liveroomInfoParams,
        }).then(res => {
            if (res.data.code === 0) {
                let data = res.data.data;
                this.setState({
                    is_promote_flag:data.is_promote_flag,
                    isInitIdentit: true,
                    isManager:data.role.is_manager
                })
                // 管理员才读取退款数量和未读评论数量
                if (data.role.is_manager) {
                     this.fetchRefundCount(liveroom_id)
                     this.fetchCommentCount(liveroom_id)
                }
                // 普通用户，非渠道主页添加首页拦截功能
                if(!data.role.is_manager && !data.is_promote_flag) {
                    AddRef();
                }
                if(Config.REDIRECT_WARN){
                    if(  data.liveroom.risk_level == 'warning' && window.location.origin != Config.WARNING_URL){
                        let params = qs.parse(window.location.search.substr(1))
                        params.__token = getToken()
                        window.location.href =  Config.WARNING_URL + window.location.pathname  + '?' + qs.stringify(params)
                    }
                }

                //初始化直播间
                this.props.dispatch({
                    type: 'LIVEROOM_INIT',
                    payload: data
                });

                document.title = data.liveroom.name;
                axios.get(`/api/liveroom/${liveroom_id}/channel_list_n`, {
                    params: {
                        limit: 10,
                        offset: 0,
                        _t: Date.now(),
                    }
                }).then((response) => {
                    let channeldata = response.data.data;
                    if (response.data.code === 0) {
                        this.props.dispatch({
                            type: 'LIVEROOM_CHANNEL',
                            payload: channeldata
                        });
                        this.props.dispatch({
                            type: 'LIVEROOM_CHANNELS_INIT',
                            payload: channeldata.channels
                        })
                    }
                })

                axios.get(`/api/liveroom/${liveroom_id}/lecture_list_n`, {
                    params: {
                        limit: 10,
                        offset: 0,
                        _t: Date.now(),
                    }
                }).then((response) => {
                    let lecturedata = response.data.data;
                    if (response.data.code === 0) {
                        this.props.dispatch({
                            type: 'LIVEROOM_LECTURE',
                            payload: lecturedata
                        });
                        this.props.dispatch({
                            type: 'LIVEROOM_LECTURES_INIT',
                            payload: lecturedata.lectures
                        })
                    }
                })


                // 初始化邀请卡
                this.props.dispatch({
                    type: 'SHARECARD_INIT',
                    payload: {
                        type: 'liveroom',
                        role: data.role,
                        id: data.liveroom.id,
                        is_resell: !!data.liveroom.vip_info && ((data.liveroom.vip_info.vip_fee * data.liveroom.vip_info.vip_resell_persent / 100) > 1),
                        title: data.liveroom.vip_info && ((data.liveroom.vip_info.vip_fee * data.liveroom.vip_info.vip_resell_persent / 100) > 1) && '赚' + renderMoney(data.liveroom.vip_info.vip_fee * data.liveroom.vip_info.vip_resell_persent / 100)
                    }
                });

                //微信分享sdk
                this.props.dispatch({
                    type: 'UPDATE_SHARE_DATA',
                    payload: {
                        title: data.share_info.share_title,
                        desc: data.share_info.share_description,
                        imgUrl: data.share_info.share_icon,
                        type: 'link',
                        link: data.share_info.share_url,
                        objectType: 'liveroom',
                        objectId: data.liveroom.id,
                        liveroom_id: data.liveroom.id
                    }
                });


                let paramsObject = getJsonFromUrl();
                if (paramsObject && paramsObject.inviter_id){
                    this.props.dispatch({
                        type: 'LIVEROOM_SET_INVITERID',
                        payload: paramsObject.inviter_id
                    })
                }

                //优惠券判断
                let params = getJsonFromUrl();

                if (params.discount_code && !data.role.is_manager) {
                    const code = params.discount_code;
                    if (code) {
                        setTimeout(() => {
                            this.props.dispatch({
                                type: 'COUPON_RECEIVE',
                                payload: {
                                    code: code,
                                    scope: 'liveroom',
                                    target: data.liveroom
                                }
                            })
                        }, 1000);
                    }
                }
            }
        }).catch((error) => {
            if (error.response && error.response.status === 404) {
                const code = error.response.data.code
                if (code === 4042) {
                    return browserHistory.replace('/lecture/error/illegal/liveroom')
                }
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: '该直播间可能存在安全风险，暂无法进行访问',
                        img: errorImg,
                        href: '/?st=liveroom_404',
                        btn: '去首页看看'
                    }
                });
            }
        });
    }

    fetchRefundCount(liveroomId) {
        axios.get(`/api/liveroom/${liveroomId}/invoice/refunding_count`)
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({refundCount: res.data.data.total_count})
                }
            })
    }

    fetchCommentCount(liveroomId) {
        axios.get(`/api/liveroom/${liveroomId}/discuss_unread_count`)
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({discussCount: res.data.data.unread_count})
                }
            })
    }

    toQrImg (str) {
        qrcode.toDataURL(str, {
            errorCorrectionLevel: 'M',
            type: 'image/png',
        }, (err, url) => {
            if (err) throw err
            this.setState({ qrImg: url })
        })
    }

    renderVipBar() {
        const {liveroom} = this.props;
        if (liveroom.liveroom.vip_info){
            if (liveroom.role.is_liveroom_vip){
                return <p>欢迎尊贵的VIP会员，本直播间原创课程免费收听</p>
            }else if (liveroom.role.is_manager){
                return <p>VIP会员，本直播间原创课程免费收听</p>
            }else if (!liveroom.role.is_liveroom_vip && !liveroom.role.is_manager){
                return <p>开通VIP会员</p>
            }
        }
    }

    renderVipLink() {
        let search = window.location.search;
        let re = /liveroom_id/ig;
        if (search === ''){
            return `/liveroom/vip?liveroom_id=${this.props.liveroom.liveroom.id}`
        }else {
            if (re.test(search)){
                return `/liveroom/vip${search}`
            }else {
                return `/liveroom/vip${search}&liveroom_id=${this.props.liveroom.liveroom.id}`
            }
        }
    }

    renderEditList() {
        let {channel, lecture} = this.props.liveroom
        let operations = [
            {
                blockContent: {
                    img: discussManage,
                    text: '评论',
                    numTag: this.state.discussCount,
                    method: () => {location.assign(`/liveroom/${this.props.params.liveroom_id}/comment`)}
                },
                hasContent: true
            },
            {
                blockContent: {
                    img: refundManage,
                    text: '退款',
                    numTag: this.state.refundCount,
                    method: () => {location.assign(`/liveroom/${this.props.params.liveroom_id}/refund`)}
                },
                hasContent: true
            },
            {
                blockContent: {
                    img: discountCoupon,
                    text: '优惠券',
                    method: () => {location.assign(`/liveroom/${this.props.params.liveroom_id}/coupon/list?scope=liveroom`)}
                },
                hasContent: true
            },
            {
                blockContent: {
                    img: vipMember,
                    text: 'VIP会员',
                    method: () => {location.assign(`/liveroom/${this.props.params.liveroom_id}/edit/vip`)}
                },
                hasContent: true
            },
            {
                blockContent: {
                    img: setting,
                    text: '设置',
                    method: () => {this.setState({openOtherActionSheet:true})}
                },
                hasContent: true
            }
        ]

        // 判断是否没有专栏
        if (channel.channels.length > 0) {
            operations.splice(0, 0, {
                nopic: true,
                blockContent: {
                    color: '#4EA8EC',
                    iconText: channel.total_count,
                    text: '专栏',
                    method: () => {location.assign(`/liveroom/${this.props.liveroom.liveroom.id}/edit/channel`)},
                    hasContent: true
                }
            })
        } else {
            operations.splice(0, 0,{
                blockContent: {
                    img: ChannelEditIcon,
                    text: '专栏',
                    method: () => {location.assign(`/liveroom/${this.props.liveroom.liveroom.id}/channel/create`)}
                },
                hasContent: true
            })
        }

        // 判断是否没有课程
        if (lecture.lectures.length > 0) {
            operations.splice(0, 0, {
                nopic: true,
                blockContent: {
                    color: '#F2725D',
                    iconText: lecture.total_count,
                    text: '课程',
                    method: () => {location.assign(`/liveroom/${this.props.liveroom.liveroom.id}/edit/lecture`)},
                    hasContent: true
                }
            })
        } else {
            operations.splice(0, 0, {
                blockContent: {
                    img: LectureEditIcon,
                    text: '课程',
                    method: () => {location.assign(`/liveroom/${this.props.liveroom.liveroom.id}/lecture/create`)}
                },
                hasContent: true
            })
        }
        return operations
    }

    render() {
        const {error} = this.props;

        if (error.showError) {
            return (
                <div className="lecture-page">
                    <WKError />
                </div>
            )
        }

        const {initialized, channelinitialized, lectureinitialized} = this.props.liveroom;

        if (!initialized || !channelinitialized || !lectureinitialized) {
            return <Page parent={this}>
                <div className="wk-inner-page main-page">
                    <Preload />
                </div>
            </Page>
        }

        const {qrcodeShow, liveroom} = this.props;
        return (
            <Page parent={this}>
                <div className='liveroom-page'>
                    <Dialog type="ios" buttons={this.state.alertCardBtn} show={this.state.alertCardShow}>
                        <div>
                            <p style={{fontWeight: 'bold',textAlign: 'left',margin: '0 0 15px 0'}}>功能更新啦</p>
                            {
                                liveroom.role.is_manager
                                ? <p>邀请卡功能全新改版，新增自定义直播间、专栏邀请卡，打造专属邀请卡提高分享率，邀请更多学员前来听课</p>
                                : <p>邀请卡功能全新改版，邀请好友收听有趣内容当然要用高逼格的邀请卡，快去分享你的邀请卡吧。</p>
                            }

                        </div>
                    </Dialog>

                    <FollowLiveroom />

                    <WKToShareCard />

                    <LiveroomSlideTopBar />

                    {liveroom.liveroom.vip_info && (liveroom.liveroom.vip_info.vip_fee > 0) &&
                    <a href={this.renderVipLink()}>
                        <div className="liveroom-vip-bar">
                            <img src={VIPIcon} alt=""/>
                            {this.renderVipBar()}
                        </div>
                    </a>
                    }

                    {this.props.newCoupon.hasCoupon && !liveroom.role.is_manager && !liveroom.role.is_liveroom_vip &&
                    <CouponBar type="liveroom" target_id={liveroom.liveroom.id}/>
                    }

                    {!liveroom.role.is_manager &&
                    <ReceiveCoupon/>
                    }

                    {(liveroom.week_sum_url && liveroom.role.is_manager) ?
                        <LiveroomWeekBar weekUrl={liveroom.week_sum_url} timeRange={liveroom.time_range}/>
                        :
                        (liveroom.role.is_manager && liveroom.role.xiaozhushou_qr !== '') && <AideCard mgTop="0" mgBottom="0" qrcode={liveroom.role.xiaozhushou_qr}/>
                    }

                    {liveroom.role.is_manager && false &&
                    <LiveroomLectureBtn />
                    }
                    {liveroom.role.is_manager &&
                    <LiveroomRealData liveroomId={this.props.params.liveroom_id} />
                    }

                    <Pay />

                    <LiveroomSchduleListArea liveroom_id={this.props.params.liveroom_id} />

                    {liveroom.channel.channels.length !== 0 &&
                    <LiveroomChannelListArea />
                    }

                    {liveroom.lecture.lectures.length !== 0 &&
                    <LiveroomClassListArea />
                    }

                    {liveroom.channel.channels.length === 0 && liveroom.lecture.lectures.length === 0 &&
                    <LiveroomNoneItem role={liveroom.role} id={this.props.params.liveroom_id}/>
                    }

                    {qrcodeShow &&
                    <LiveroomQrcode />
                    }

                    {this.state.isInitIdentit ?
                        this.state.isManager ?
                            <WKOperation isNew={this.state.refundCount > 0 || this.state.discussCount > 0} editList={this.renderEditList()} openOtherActionSheet={this.state.openOtherActionSheet} liveroomId={this.props.params.liveroom_id}/>
                            :
                            <LiveroomBottomStudentNav is_promote_flag={this.state.is_promote_flag}/>

                        :null
                    }
                    <WKVisible create={this.state.isShowRebateModal && this.state.qrImg}>
                        <LiveroomRebateModal
                            show={true}
                            onClickMask={e => this.setState({ isShowRebateModal: false })}
                            qrImg={this.state.qrImg}
                        />
                    </WKVisible>
                </div>
            </Page>
        )
    }
}

export default connect(state => ({
    account: state.account,
    liveroom: state.liveroom,
    qrcodeShow: state.liveroom.qrcodeShow,
    error: state.error,
    showImgDialog: state.activity.showImgDialog,
    newCoupon: state.newCoupon,
}), dispatch => bindActionCreators({ ...liveroomAction, dispatch}, dispatch))(LiveroomPage)



// WEBPACK FOOTER //
// ./src/pages/LiveroomPage.js